var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBreadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 97,
    viewBox: "0 0 35 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.844 95.5907C16.7586 96.5053 18.2414 96.5053 19.156 95.5907L34.0598 80.6869C34.9744 79.7723 34.9744 78.2895 34.0598 77.3749C33.1452 76.4604 31.6624 76.4604 30.7479 77.3749L17.5 90.6228L4.25215 77.3749C3.33757 76.4604 1.85476 76.4604 0.940183 77.3749C0.0256095 78.2895 0.0256095 79.7723 0.940183 80.6869L15.844 95.5907ZM15.1581 0.258301L15.1581 93.9348H19.8419L19.8419 0.258301L15.1581 0.258301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBreadArrow);
export default __webpack_public_path__ + "static/media/contact-bread-arrow.65b591d376feb97471bcc46ad58ec67b.svg";
export { ForwardRef as ReactComponent };